import React from "react";
import ForgotForm from "./forgotForm";
const ForgotPassword = () => {
  return (
    <div className="min-h-[100vh] bg-[#f1f1f1] pt-2 md:pt-14">
      <ForgotForm />
    </div>
  );
};

export default ForgotPassword;
